import { mapState, mapActions } from 'vuex';
import Keypress from 'keypress.js';
import Profile from '@/vuex/orm/models/Profile';

export default {
  data() {
    return {
      listener: null,
    };
  },

  computed: {
    isOwnProfile() {
      return this.$route.name === 'profile-view';
    },

    ...mapState({
      profile: (state) => state.profile.profile,
    }),
  },

  watch: {
    $route() {
      if (['profile', 'profile-view', 'profile-edit', 'profile-backer'].includes(this.$route.name)) {
        this.loadProfile();
      }
    },
  },

  mounted() {
    this.loadListeners();
  },

  beforeDestroy() {
    this.unloadsListeners();
  },

  created() {
    this.loadProfile();
  },

  methods: {
    ...mapActions([
      'getProfile', //
    ]),

    loadListeners() {
      this.listener = new Keypress.Listener();

      Bus.$on('refresh', () => {
        this.loadProfile();
      });

      Bus.$on('profile:previous', () => {
        const profiles = Profile.query()
          .orderBy('lastOnline')
          .get();
        let profileIndex = 0;
        let prevProfile = false;
        profiles.forEach((profile) => {
          profileIndex += 1;
          if (profile.profile.uuid === this.$route.params.profile) {
            if (profileIndex === 1) {
              prevProfile = profiles[profiles.length - 1].profile.uuid;
            } else {
              prevProfile = profiles[profileIndex - 2].profile.uuid;
            }
          }
        });

        if (prevProfile) {
          this.$router.push(`/profile/${prevProfile}`);
        }
      });

      Bus.$on('profile:next', () => {
        console.log('profile:next');

        console.log(Profile.query().count());

        const profiles = Profile.query()
          .orderBy('lastOnline')
          .get();
        let profileIndex = 0;
        let nextProfile = false;
        profiles.forEach((profile) => {
          profileIndex += 1;
          if (profile.profile.uuid === this.$route.params.profile) {
            if (profileIndex === profiles.length) {
              nextProfile = profiles[0].profile.uuid;
            } else {
              nextProfile = profiles[profileIndex].profile.uuid;
            }
          }
        });

        if (nextProfile) {
          this.$router.push(`/profile/${nextProfile}`);
        }
      });

      this.listener.simple_combo('left', (event) => {
        if (this.isOwnProfile || $('#blueimp-gallery').is(':visible') || event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
          return true;
        }

        Bus.$emit('profile:previous');
      });

      this.listener.simple_combo('right', (event) => {
        if (this.isOwnProfile || $('#blueimp-gallery').is(':visible') || event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
          return true;
        }

        Bus.$emit('profile:next');
      });
    },

    unloadsListeners() {
      console.log('unloadsListeners');
      Bus.$off('refresh');
      Bus.$off('profile:previous');
      Bus.$off('profile:next');
      this.listener.unregister_combo('left');
      this.listener.unregister_combo('right');
    },

    async loadProfile() {
      // console.log(this.$route.name);
      // console.log(this.$auth.user());
      // console.log(this.$route.params);
      try {
        await this.getProfile({
          params: {
            uuid: ['profile-view', 'profile-edit', 'profile-backer'].includes(this.$route.name) ? this.$auth.user().profile.uuid : this.$route.params.profile,
          },
        })
          .then(() => {})
          .catch((err) => {
            if (err.response.data === 'profile-not-found') {
              // this.$swal({
              //   title: 'Profile not found',
              //   showCloseButton: true,
              //   timer: 5000,
              // }).then(() => {
              //   this.$router.push(this.navigate('/'));
              // });
            }
          });
      } catch (error) {
        // error
        // console.log('error loading profile!');
      }
    },
  },
};
